import React, { useState } from "react";
// import { Link } from 'react-router-dom';
import Header from "./../Layout/Header1";
import Footer5 from "./../Layout/Footer1";

import bgimg from "./../../images/background/bg2.jpg";
// import FileBase from 'react-file-base64';

import { client } from "../../sanityClient";

// const initialState = {};

function StudentForm() {
  const [formData, setFormData] = useState({
    fullName: "",
    idNumber: "",
    gender: "",
    email: "",
    classYear: "",
    dateOfBirth: "",
    address: "",
    contact: "",
    yearAddmitted: "",
    chronicDiseases: "",
    orphan: "",
    parent: "",
    occupation: "",
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    fullName,
    idNumber,
    gender,
    dateOfBirth,
    address,
    contact,
    classYear,
    yearAddmitted,
    chronicDiseases,
    orphan,
    parent,
    occupation,
  } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: "studentForm",
      fullName: formData.fullName,
      idNumber: formData.idNumber,
      gender: formData.gender,
      dateOfBirth: formData.dateOfBirth,
      address: formData.address,
      contact: formData.contact,
      yearAddmitted: formData.yearAddmitted,
      classYear: formData.classYear,
      chronicDiseases: formData.chronicDiseases,
      orphan: formData.orphan,
      parent: formData.parent,
      occupation: formData.occupation,
    };

    client
      .create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
      })
      .catch((err) => console.log(err));
    setFormData({
      fullName: "",
      idNumber: "",
      gender: "",
      email: "",
      dateOfBirth: "",
      address: "",
      contact: "",
      yearAddmitted: "",
      classYear: "",
      chronicDiseases: "",
      orphan: "",
      parent: "",
      occupation: "",
    });
    setTimeout(() => {
      setIsFormSubmitted(false);
    }, 5000);
  };
  return (
    <>
      <Header />
      <div className="full-section">
        {/* <!-- inner page banner --> */}
        <div
          className="dlab-bnr-inr overlay-primary-dark contact-page"
          style={{ backgroundImage: "url(" + bgimg + ")" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-xs-4">
                <div className="row text-white">
                  <div className="col-lg-12 col-md-6 m-b30">
                    <div className="icon-bx-wraper bx-style-1 p-a20 radius-sm">
                      <div className="icon-content">
                        <h5 className="dlab-tilte">
                          <span className="icon-sm text-primary text-left">
                            <i className="ti-location-pin"></i>
                          </span>
                          Our Address
                        </h5>
                        <p> Zain Main Rd. Gudele Jopa Opp. V.S.S C.o, Juba South Sudan</p>
                        <h6 className="m-b15 font-weight-400">
                          <i className="ti-alarm-clock"></i> Office Hours
                        </h6>
                        <p className="m-b0">Mon To Fri - 08.00am-02.45pm</p>
                        <p>Saturday to Sunday - Close</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-6 m-b30 ">
                    <div className="icon-bx-wraper bx-style-1 p-a20 radius-sm">
                      <div className="icon-content">
                        <h5 className="dlab-tilte">
                          <span className="icon-sm text-primary text-left">
                            <i className="ti-email"></i>
                          </span>
                          E-mail
                        </h5>
                        <p className="m-b0">jubaproperint2021@gmail.com</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-6 m-b30 ">
                    <div className="icon-bx-wraper bx-style-1 p-a20 radius-sm">
                      <div className="icon-content">
                        <h5 className="dlab-tilte">
                          <span className="icon-sm text-primary text-left">
                            <i className="ti-mobile"></i>
                          </span>
                          Phone Numbers
                        </h5>
                        <p>+21698487054</p>
                        <p>+21698487054</p>
                        <p>+21698487054</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-xs-8">
                <form className="inquiry-form dzForm">
                  <div className="dzFormMsg"></div>
                  <h3 className="box-title m-t0 m-b10">
                    Student's Registration Form{" "}
                    <span className="bg-primary"></span>
                  </h3>
                  <p>
                    Please give us accurate information and keep in mind that
                    giving false information is a crime and violation of our
                    school's policy.
                  </p>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <div className="input-group">
                          <span className="input-group-addon">
                            <i className="ti-user text-primary"></i>
                          </span>
                          <input
                            autoFocus
                            className="form-control"
                            type="text"
                            name="fullName"
                            placeholder="Enter your Full Name here......"
                            value={fullName}
                            onChange={handleChangeInput}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <div className="input-group">
                          <span className="input-group-addon">
                            <i className="ti-id-badge text-primary"></i>
                          </span>
                          <input
                            className="form-control"
                            type="text"
                            name="idNumber"
                            placeholder="Form Code"
                            required
                            value={idNumber}
                            onChange={handleChangeInput}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="idhref">Gender</label>
                        <div className="input-group">
                          <span className="input-group-addon">
                            <i className="ti-user text-primary"></i>
                          </span>

                          <select
                            className="form-control"
                            type="text"
                            name="gender"
                            placeholder="Gender"
                            value={gender}
                            onChange={handleChangeInput}
                            required
                          >
                            <option>--Select--</option>

                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="idhref">Class</label>

                        <div className="input-group">
                          <span className="input-group-addon">
                            <i className="ti-user text-primary"></i>
                          </span>

                          <select
                            className="form-control"
                            type="text"
                            name="classYear"
                            value={classYear}
                            onChange={handleChangeInput}
                            required
                          >
                            <option>--Select--</option>

                            <option value="Senior One">Senior One </option>
                            <option value="Senior Two ">Senior Two </option>
                            <option>Senior Three Science </option>
                            <option>Senior Three Arts </option>
                            <option>Senior Four Science </option>
                            <option>Senior Four Arts </option>
                            <option>Primary One</option>
                            <option>Primary Two</option>
                            <option>Primary Three</option>
                            <option>Primary Four</option>
                            <option>Primary Five</option>
                            <option>Primary Six</option>
                            <option>Primary Seven</option>
                            <option>Primary Eight</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="idhref">D.O.B</label>

                        <div className="input-group">
                          <span className="input-group-addon">
                            <i className="ti-calendar text-primary"></i>
                          </span>
                          <input
                            className="form-control"
                            type="date"
                            name="dateOfBirth"
                            placeholder="D.O.B"
                            value={dateOfBirth}
                            onChange={handleChangeInput}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    {/* new added data */}
                    <div className="col-lg-6">
                      <div className="form-group">
                        <div className="input-group">
                          <span className="input-group-addon">
                            <i className="ti-face-sad text-primary"></i>
                          </span>
                          <input
                            className="form-control"
                            type="text"
                            name="chronicDiseases"
                            placeholder="chronic Diseases"
                            value={chronicDiseases}
                            onChange={handleChangeInput}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="idhref">Orphan</label>
                        <div className="input-group">
                          <span className="input-group-addon">
                            <i className="ti-user text-primary"></i>
                          </span>
                          <select
                            className="form-control"
                            type="text"
                            name="orphan"
                            placeholder="Orphan Yes or No"
                            value={orphan}
                            onChange={handleChangeInput}
                            required
                          >
                            <option>--not selected ---</option>
                            <option value="Yes" selected>
                              Yes
                            </option>
                            <option value="No">No</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <div className="input-group">
                          <span className="input-group-addon">
                            <i className="ti-user text-primary"></i>
                          </span>
                          <input
                            className="form-control"
                            type="text"
                            name="parent"
                            placeholder=" Parent's/ Guardian's Name"
                            value={parent}
                            onChange={handleChangeInput}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <div className="input-group">
                          <span className="input-group-addon">
                            <i className="ti-calendar text-primary"></i>
                          </span>
                          <input
                            className="form-control"
                            type="text"
                            name="occupation"
                            placeholder="Occupation"
                            value={occupation}
                            onChange={handleChangeInput}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    {/* new added datas end here */}

                    <div className="col-lg-6">
                      <div className="form-group">
                        <div className="input-group">
                          <span className="input-group-addon">
                            <i className="ti-location-pin text-primary"></i>
                          </span>
                          <input
                            className="form-control"
                            type="text"
                            name="address"
                            placeholder="Residence "
                            value={address}
                            onChange={handleChangeInput}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <div className="input-group">
                          <span className="input-group-addon">
                            <i className="ti-mobile text-primary"></i>
                          </span>
                          <input
                            className="form-control"
                            type="text"
                            name="contact"
                            placeholder="Contact/E-mail"
                            value={contact}
                            onChange={handleChangeInput}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="idhref">Year Addmitted</label>
                        <div className="input-group">
                          <span className="input-group-addon">
                            <i className="ti-write text-primary"></i>
                          </span>
                          <select
                            className="form-control"
                            type="text"
                            name="yearAddmitted"
                            value={yearAddmitted}
                            onChange={handleChangeInput}
                            required
                          >
                            <option>--Select--</option>

                            <option>2021</option>
                            <option>2022</option>
                            <option>2023</option>
                            <option>2024</option>
                            <option>2025</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <div className="input-group">
                          <div
                            className="g-recaptcha"
                            data-sitekey="6LefsVUUAAAAADBPsLZzsNnETChealv6PYGzv3ZN"
                            data-callback="verifyRecaptchaCallback"
                            data-expired-callback="expiredRecaptchaCallback"
                          ></div>
                          <input
                            className="form-control d-none"
                            data-recaptcha="true"
                            required
                            data-error="Please complete the Captcha"
                          />

                          {isFormSubmitted && (
                            <div className="col-lg-12 site-button">
                              Congratulations on successfully enrolling in Juba
                              Proper International College. Please be patient as
                              we will respond in a timely manner.{" "}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <button
                        type="button"
                        className="site-button button-lg"
                        onClick={handleSubmit}
                      >
                        <span>{!loading ? "Submit" : "Saving..."}</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- inner page banner END --> */}
      </div>

      <Footer5 />
    </>
  );
}

export default StudentForm;
